
import request from "@/utils/request";
import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)
/**
 * 动态获取日期
 * @param {*} type      month: Y-M  date: Y-M-D  datetime: Y-M-D H:m
 * @param {*} num       -1: 前一天 0: 当天 1: 后一天
 * @param {*} datetime  以哪一天为标准 （string格式和time格式都可以）
 */
const getDynamicTime = (type, num, datetime) => {
    let date
    if (datetime) {
        date = new Date(datetime)
    } else {
        date = new Date()
    }
    if (type == 'month') {
        let date1 = new Date(date.getTime())
        let Y = date1.getFullYear()
        let M = date1.getMonth() + 1
        if (num >= 0) {
            let years = parseInt((M + num) / 12)
            Y = Y + years
            M = M + num - years * 12
        } else {
            let years = parseInt((M + num) / 12) - 1
            Y = Y + years
            M = M + num - years * 12
        }
        return Y + '-' + (M < 10 ? '0' + M : M)
    } else if (type == 'date') {
        let date2 = new Date(date.getTime() + num * 24 * 3600 * 1000)
        let Y = date2.getFullYear()
        let M = date2.getMonth() + 1
        let D = date2.getDate()
        return Y + '-' + (M < 10 ? '0' + M : M) + '-' + (D < 10 ? '0' + D : D)
    } else if (type == 'datetime') {
        let date3 = new Date(date.getTime() + num * 24 * 3600 * 1000)
        let Y = date3.getFullYear()
        let M = date3.getMonth() + 1
        let D = date3.getDate()
        let H = date3.getHours()
        let m = date3.getMinutes()
        return (
            Y +
            '-' +
            (M < 10 ? '0' + M : M) +
            '-' +
            (D < 10 ? '0' + D : D) +
            ' ' +
            (H < 10 ? '0' + H : H) +
            ':' +
            (m < 10 ? '0' + m : m)
        )
    }
}
// 暴利点击
const btnClickedFn = (self) => {
    self.btnClicked = true
    setTimeout(() => {
        self.btnClicked = false
    }, 1000)
}
// 时间格式化
const timeFormat = (time, showMore = false) => {
    var time = new Date(time)
    let year = time.getFullYear()
    let month = time.getMonth() + 1
    let day = time.getDate()
    let h = time.getHours()
    h = h < 10 ? '0' + h : h
    let minutes = time.getMinutes()
    minutes = minutes < 10 ? '0' + minutes : minutes
    let second = time.getSeconds()
    second = second < 10 ? '0' + second : second
    let result = year + '-' + month + '-' + day
    if (showMore) {
        return result + ` ${h}:${minutes}:${second}`
    }
    return year + '-' + month + '-' + day
}
// 时间格式化  月日拼0
const timeFormatNew = (time, showMore = false) => {
    var time = new Date(time)
    let year = time.getFullYear()
    let month = time.getMonth() + 1
    let day = time.getDate()
    let h = time.getHours()
    h = h < 10 ? '0' + h : h
    let minutes = time.getMinutes()
    minutes = minutes < 10 ? '0' + minutes : minutes
    month = month < 10 ? '0' + month : month
    day = day < 10 ? '0' + day : day
    let second = time.getSeconds()
    second = second < 10 ? '0' + second : second
    let result = year + '-' + month + '-' + day
    if (showMore) {
        return result + ` ${h}:${minutes}:${second}`
    }
    return year + '-' + month + '-' + day
}

// 消杀的utils --------------
import md5 from 'js-md5'
import { reject } from "lodash";

const checkToken = () => {
    let myDate = new Date() // 获取系统当前时间

    var Y = myDate.getFullYear()
    var m = parseInt(myDate.getMonth()) + 1
    var d = parseInt(myDate.getDate())
    var H = parseInt(myDate.getHours())

    if (m < 10) {
        m = '0' + m
    }
    if (d < 10) {
        d = '0' + d
    }
    if (H < 10) {
        H = '0' + H
    }

    m = m + ''
    d = d + ''
    H = H + ''

    var code = md5(Y + '****' + m + '******' + d + '********' + H)
    var sub = m + d + H

    var abc = {
        q: 1,
        w: 2,
        e: 3,
        r: 4,
        t: 5,
        y: 6,
        u: 7,
        i: 8,
        o: 9,
        p: 0,
        l: 1,
        k: 2,
        j: 3,
        h: 4,
        g: 5,
        f: 6,
        d: 7,
        s: 8,
        a: 9,
        z: 0,
        x: 6,
        c: 7,
        v: 8,
        b: 9,
        n: 0,
        m: 1,
    }

    var rand = ''
    for (var i = 0; i < 6; i++) {
        var _code = code.substr(sub[i], 1)
        _code = abc[_code] ? abc[_code] : _code
        rand += _code
    }
    return md5(rand)
}

const timeToDate = () => {
    let date = new Date() //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let Y = date.getFullYear() + '-'
    let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
    let D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
    return Y + M + D
}
const timeToDate2 = () => {
    let date = new Date() //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let Y = date.getFullYear()
    let M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
    let D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
    return Y + M + D
}

const timeToTime = () => {
    let date = new Date() //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let Y = date.getFullYear() + '-'
    let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
    let D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
    let h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
    let m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
    return Y + M + D + h + m
}

// 时间格式化  月日拼0, 使用"-"会导致new Date的时间是早上8点, 所以改用"/""
const dateFormat = (time = new Date(), formate = 'YYYY-MM-DD', delimiter = '/') => {
    let date = typeof time === 'string' ? time.replace(/-/g, "/") : time
    date = new Date(date)
    let y = date.getFullYear()
    let m = date.getMonth() + 1
    let d = date.getDate()
    let hh = date.getHours()
    hh = hh < 10 ? '0' + hh : hh
    let mm = date.getMinutes()
    mm = mm < 10 ? '0' + mm : mm
    m = m < 10 ? '0' + m : m
    d = d < 10 ? '0' + d : d
    let ss = date.getSeconds()
    ss = ss < 10 ? '0' + ss : ss
    let result = ''

    if (formate === 'YYYY-MM-DD HH:mm:ss') {
        result = `${y}${delimiter}${m}${delimiter}${d} ${hh}:${mm}:${ss}`
    }
    if (formate === 'YYYY-MM-DD') {
        result = `${y}${delimiter}${m}${delimiter}${d}`
    }
    if (formate === 'YYYY-MM') {
        result = `${y}${delimiter}${m}`
    }
    if (formate === 'HH:mm:ss') {
        result = `${hh}:${mm}:${ss}`
    }
    if (formate === 'HH:mm') {
        result = `${hh}:${mm}`
    }
    if (formate === 'YYYY-MM-DD HH:mm') {
        result = `${y}${delimiter}${m}${delimiter}${d} ${hh}:${mm}`
    }
    return result
}

const formatDateTime = (date, format) => {
    const o = {
        "M+": date.getMonth() + 1, // 月份
        "d+": date.getDate(), // 日
        "h+": date.getHours() % 12 === 0 ? 12 : date.getHours() % 12, // 小时
        "H+": date.getHours(), // 小时
        "m+": date.getMinutes(), // 分
        "s+": date.getSeconds(), // 秒
        "q+": Math.floor((date.getMonth() + 3) / 3), // 季度
        S: date.getMilliseconds(), // 毫秒
        a: date.getHours() < 12 ? "上午" : "下午", // 上午/下午
        A: date.getHours() < 12 ? "AM" : "PM", // AM/PM
    };
    if (/(y+)/.test(format)) {
        format = format.replace(
            RegExp.$1,
            (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
    }
    for (let k in o) {
        if (new RegExp("(" + k + ")").test(format)) {
            format = format.replace(
                RegExp.$1,
                RegExp.$1.length === 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
            );
        }
    }
    return format;
}
const clickEvt = (params) => {
    return request({
        url: 'click',
        method: 'post',
        data: params
    }).then(res => {
        resolve(res)
    }).catch(err => {
        reject(err)
    })
}
/**
 * 下载文件：常用下载模板，导出文件
 * @param url
 * @param fileName
 */
const downloadFile = (url, fileName) => {
    console.log(url, fileName);
    
    var eleLink = document.createElement('a')
    eleLink.download = fileName
    eleLink.href = url
    // 触发点击
    document.body.appendChild(eleLink)
    eleLink.click()
    // 然后移除
    document.body.removeChild(eleLink)
}
export { getDynamicTime, btnClickedFn, timeFormat, timeFormatNew, checkToken, timeToDate, timeToDate2, timeToTime, dateFormat, formatDateTime, clickEvt, downloadFile }
